import React from "react";
import "../proposalForm.css";

export const Registration = (props) => {
  // Group registration types by category
  const groupedRegistrationTypes = props.registrationTypes.reduce((acc, pt) => {
    const category = pt.category || "Other"; // Default to "Other" if no category
    if (!acc[category]) {
      acc[category] = [];
    }
    acc[category].push(pt);
    return acc;
  }, {});

  // Sort registration types within each category by categoryOrder, then by order
  Object.keys(groupedRegistrationTypes).forEach((category) => {
    groupedRegistrationTypes[category].sort((a, b) => {
      // First, sort by categoryOrder (if it exists)
      const categoryOrderA = a.categoryOrder !== undefined ? Number(a.categoryOrder) : 9999;
      const categoryOrderB = b.categoryOrder !== undefined ? Number(b.categoryOrder) : 9999;

      if (categoryOrderA !== categoryOrderB) {
        return categoryOrderA - categoryOrderB;
      }

      // If categoryOrder is the same, sort by order
      const orderA = a.order !== undefined ? Number(a.order) : 9999;
      const orderB = b.order !== undefined ? Number(b.order) : 9999;

      if (orderA !== orderB) {
        return orderA - orderB;
      }

      // If both categoryOrder and order are the same, sort alphabetically by name
      return a.name.localeCompare(b.name);
    });
  });

  // Sort categories by order number from registrationCategoryTypes
  const sortedCategories = Object.keys(groupedRegistrationTypes).sort((a, b) => {
    // If registrationCategoryTypes is available, use the order property
    if (props.registrationCategoryTypes && Array.isArray(props.registrationCategoryTypes)) {
      const categoryA = props.registrationCategoryTypes.find(cat => cat.category === a);
      const categoryB = props.registrationCategoryTypes.find(cat => cat.category === b);

      // Get order values, default to 9999 if not found
      const orderA = categoryA?.order !== undefined ? Number(categoryA.order) : 9999;
      const orderB = categoryB?.order !== undefined ? Number(categoryB.order) : 9999;

      // Always sort by order number (ascending) when registrationCategoryTypes is available
      return orderA - orderB;
    }

    // Fallback: Keep "Other" at the bottom, sort rest alphabetically
    if (a === "Other") return 1;
    if (b === "Other") return -1;
    return a.localeCompare(b);
  });

  return (
    <div>
      <div className="form-group">
        <label>
          <strong>Registration</strong>
        </label>
        <select
          name={props.object[1].registration}
          id={props.object[1].registration}
          className="form-control"
          style={{
            borderLeftColor: props.object[1].value ? "green" : (props.emptyBorderColor || "#ced4da"),
            borderLeftWidth: "5px",
          }}
          onChange={props.handleRegistrations(props.object[1].registration)}
          defaultValue={props.object[1].value ? props.object[1].value : ""}
        >
          <option value={""} key="empty-option">
            Select Registration
          </option>
          {sortedCategories.map((category, categoryIndex) => (
            <optgroup label={category} key={`category-${categoryIndex}`}>
              {groupedRegistrationTypes[category].map((pt, index) => (
                <option value={pt.name} key={`${category}-${index}`}>
                  {pt.name}
                </option>
              ))}
            </optgroup>
          ))}
        </select>
      </div>
    </div>
  );
};
